export type ToolTipInfo = {
  info: string;
  link?: string;
};

const toolTips = {
  triggerPanel: {
    info: "Use Q&A to set up triggers and refine and broaden your bot's responses!",
    link: 'https://customers.ai/help/article/ebz3gg5w7t-q-a-overview',
  },
  commentGuards: {
    info:
      'Facebook Comment Guards automatically send a chat message to anyone who comments on your posts ' +
      'and boosted posts.',
    link: 'https://customers.ai/help/article/xcr08txqxa-post-comment-guard-video',
  },
  adConfigs: {
    info: 'Create enticing opt-in pages for your Facebook "Send to Messenger" advertisements.',
    link: 'https://customers.ai/help/article/gtwfu1tsmn',
  },
  messangerAds: {
    info: 'Create enticing opt-in pages for your Facebook "Send to Messenger" advertisements.',
    link: 'https://customers.ai/help/article/gtwfu1tsmn',
  },
  landingPages: {
    info: 'Create landing pages to drive traffic to you Bot.',
    link: 'https://customers.ai/help/article/ltmot4wrsr-landing-pages',
  },
  promoBlasters: {
    info: 'Create Facebook Sponsored Messages that drive people into your Chatbot',
    link: '',
  },
  chatBlaster: {
    info: 'Chat Blaster allows you to send mass messages to your contacts, based on a selected audience!',
    link: 'https://customers.ai/help/article/vc8wb3rpu6-send-a-mass-message-blaster',
  },
  dripCampaign: {
    info:
      'Set up a Drip Campaign to send a series of strategically timed messages (Drips) to a specified audience!' +
      ' Gain traction, offer tips, and more!',
    link: 'https://customers.ai/help/article/h9ckxgr6eh-creating-a-drip-campaign-video',
  },
  pages: {
    info:
      '"Dialogues" are the framework of your Bot.  Add Text, Image, Video and other Widgets to Dialogues ' +
      'and connect them with links.',
    link: 'https://customers.ai/help/category/ncjcpi8mxn-building-chatbots',
  },
  rssBlaster: {
    info: "RSS Blaster reads from your RSS feed and sends updates to your contacts whenever there's a new post!",
    link: 'https://customers.ai/help/article/g2kjjn7s5a-rss-blaster-video',
  },
  connections: {
    info: 'Connect your Customers.ai contacts to other systems!',
    link: 'https://customers.ai/help/article/5hfyly47aj-connects-and-integrations',
  },
  settings: {
    info: 'Your settings allow you to control the basics of your bot',
    link: 'https://customers.ai/help/article/zycny3hlt1-bot-settings',
  },
  facebookPageWelcomer: {
    info: 'The first dialogue when a FB user messages your page',
    link: 'https://customers.ai/help/article/yjkeatbg5d-facebook-page-welcomer',
  },
};

export default toolTips;
